/* eslint-disable */
import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";

// multi date picker
import DatePicker from "react-multi-date-picker";
import { spanishLocale } from  "helpers/DatePicker-Es";
import {formatStringDate} from "helpers/DateCalculation";

//import date format from helper folder
import { formatDate } from "helpers/DateCalculation";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/* Importing react select */
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

//import options from json file
import ReserveStatus from "data/Prod/ReserveStatus.json";

//import context
import { GlobalProvider } from "context/GlobalContext";

/*import url and gateway methods */
import { postData, getData, putData, deleteData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

const ReserveFilter = ({
  setColumns,
  filterTitle,
  setFilterTitle,
  filterJsonData,
  setfilterJsonData,
  filterId,
  setFilterId,
  filterDefault,
  setFilterDefault,
  setReloadFilterList,
  resetFilterData,
  setResetFilterData,
  isSearchExecute,
  setIsSearchExecute,
}) => {
  const token = localStorage.getItem("token"); // token
  const { t,  i18n} = useTranslation(); //for translation

  const todayValue = new Date().toISOString().split("T")[0];

  const {
    // searchReserveDate,
    setSearchReserveDate,
    setSearchReserveIdList,
    setSearchReserveAmbIdList,
    setSearchReserveActivity,
    setSearchReserveLabels,
    setSearchReserveBenificiaries,
    setSearchReserveClients,
    setSearchReserveExcludeClients,
    setSearchReserveEducators,
    setSearchReserveStatus,
    setisConsecutiveReserveFilter,
    setIsTemplateReserveFilter,
    setUnsentMailReserveFilter,
    setIsDefaultReserveFilter,
    setReloadReservationList,
    // reloadRefresh,
    // setReloadRefresh,
  } = useContext(GlobalProvider);

  const [labelList, setlabelList] = useState([]); // for label list
  const [activityList, setActivityList] = useState([]); // for activity list

  const [educatorList, setEducatorList] = useState([]); //educator option
  const [clientList, setClientList] = useState([]); //client option
  const [benificiaryList, setBenificiaryList] = useState([]); //benificiary option

  const [activitySearchInput, setActivitySearchInput] = useState('');
  const [labelSearchInput, setLabelSearchInput] = useState('');
  const [beneficiarySearchInput, setBeneficiarySearchInput] = useState('');
  const [clientSearchInput, setClientSearchInput] = useState('');
  const [excludeClientSearchInput, setExcludeClientSearchInput] = useState('');
  const [educatorSearchInput, setEducatorSearchInput] = useState('');

  const activitySelectRef = useRef(null);
  const labelSelectRef = useRef(null);
  const beneficiarySelectRef = useRef(null);
  const clientSelectRef = useRef(null);
  const excludeClientSelectRef = useRef(null);
  const educatorSelectRef = useRef(null);

  const getSortedOptions = (options, inputValue) => {
    if (!inputValue) return options;
    const lower = inputValue.toLowerCase();
    return [...options].sort((a, b) => {
      const aStarts = a.label.toLowerCase().startsWith(lower);
      const bStarts = b.label.toLowerCase().startsWith(lower);
      if (aStarts && !bStarts) return -1;
      if (!aStarts && bStarts) return 1;
      return 0;
    });
  };

  const handleInputChange = (setter, ref) => (val) => {
    setter(val);
    if (ref.current) {
      ref.current.setState({ focusedOption: null });
    }
  };

  const [isConseCutive, setIsConseCutive] = useState(false);
  const [isTemplate, setIsTemplate] = useState(false);
  const [unsentMail, setUnsentMail] = useState(false);
  const [isDefault, setIsDefault] = useState(false);

  const [filterName, setFilterName] = useState("");

  //use state for select filter
  // const [selectedFilterValue, setSelectedFilterValue] = useState(null);

  const [selectedDatesPick, setSelectedDatesPick] = useState([]);

  // Hook for date compare validation
  const [dateWarning, setDateWarning] = useState(false);

  const [selectedFilterData, setSelectedFilterData] = useState({
    showColumnValue: null,
    showSelectedColumns: [],
    selectedRadioName: "",
    fromDate: "",
    toDate: "",
    selectedDate: "",
    reserveIdValue: null,
    reserveSelectedIds: [],
    reserveAmbIdValue: null,
    reserveSelectedAmbIds: [],
    reserveStatusValue: null,
    reserveStatusOption: [],
    mailValue: null,
    mailOptions: null,
    benificiaryValue: null,
    benificiaryOptions: [],
    activityValue: null,
    activityOptions: [],
    labelValue: null,
    labelOptions: [],
    clientValue: null,
    clientOptions: [],
    excludedClientValue: null,
    excludedClientOptions: [],
    educatorValue: null,
    educatorOptions: [],
    isConsecutive: false,
    isTemplate: false,
    unsentMail: false,
  });

  /* selecting options ends */

  //function for select radio
  const radioCheckHandler = (e) => {
    setDateWarning(false);
    setSelectedFilterData((prevData) => ({
      ...prevData,
      selectedRadioName: e.target.value,
    }));
  };

  /* function to get all activity */
  const getAllActivity = async () => {
    let requestUrl =
      url.API_BASEURL +
      url.API_GET_ALL_ACTIVITY +
      `?token=${token}&isselect=${true}`;

    const response = await getData(requestUrl);

    if (response.status) {
      setActivityList(response.data);
    }
  };

  /* function to get all client list */
  const getALlClientList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&slug=client&limit=0`;

      const response = await getData(requestUrl);

      if (response.status) {
        setClientList(response.data);
        setBenificiaryList(response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* function to get all client list */
  const getALlEducatorList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&slug=educator&limit=0`;

      const response = await getData(requestUrl);

      if (response.status) {
        setEducatorList(response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* function to get all labels */
  const getAllLabels = async () => {
    let requestUrl =
      url.API_BASEURL +
      url.API_GET_ALL_TAG +
      `?token=${token}&isselect=${true}`;

    const response = await getData(requestUrl);

    if (response.status) {
      setlabelList(response.data);
    }
  };

  const datePickerChangeHandler = (clickdate) => {
    // Uncomment the following line if you want to log the clickdate
    // console.log("clickdate", clickdate);

    let currentDateSelected = ""; // Will hold the formatted dates as a string
    let currentDateArr = []; // Will hold the formatted dates as an array

    if (clickdate) {
      // Convert clicked dates to an array of formatted date strings
      currentDateArr = clickdate.map((date) => formatDate(new Date(date)));

      // Creating a comma-separated string of formatted dates
      clickdate.map((date, index) => {
        if (currentDateSelected) {
          currentDateSelected =
            currentDateSelected + "," + formatDate(new Date(date));
        } else {
          currentDateSelected = formatDate(new Date(date));
        }
      });
    }

    setSelectedDatesPick(currentDateArr); // Updating selected dates as an array

    // Updating selectedFilterData state
    setSelectedFilterData((prevData) => ({
      ...prevData,
      selectedRadioName: "eventdate",
      selectedDate: currentDateSelected,
      fromDate: "",
      toDate: "",
    }));

    // Uncomment the following line if you want to log the selectedDate
    // console.log("selectedDate", currentDateSelected);
  };

  // reset selected filter from filter select
  const deleteSelectedFilter = async () => {
    if (filterId && filterName !== "") {
      try {
        let requestUrl =
          url.API_BASEURL +
          url.API_DELETE_FILTER +
          `/${filterId}` +
          `?token=${token}`;

        const response = await deleteData(requestUrl);

        // console.log(`filterData response ==========>>>`, response);

        if (response.status) {
          setFilterName("");
          setFilterTitle("");
          setfilterJsonData(null);
          setFilterId(null);
          setFilterDefault(false);
          setReloadFilterList(true);
          resetFilterHandler();
        }
      } catch (error) {
        console.error(error.message);
      }
    }
    // resetHandler();
  };

  /* function to save reservation */
  const saveWithFilterSearchHandler = async () => {
    let filterData = {
      name: filterName,
      parameters: JSON.stringify(selectedFilterData),
      moduleslug: "reserve",
      isdefault: isDefault,
    };

    // console.log(`filterData ==========>>>`, filterData);

    try {
      // if selectedFilterId then edit,

      // else add new
      let requestUrl = url.API_BASEURL;

      if (filterId && filterName !== "") {
        requestUrl =
          requestUrl +
          url.API_UPDATE_FILTER +
          `/${filterId}` +
          `?token=${token}`;
      } else {
        requestUrl = requestUrl + url.API_ADD_NEW_FILTER + `?token=${token}`;
      }

      const response = filterId
        ? await putData(requestUrl, filterData)
        : await postData(requestUrl, filterData);

      // console.log(`filterData response ==========>>>`, response);

      if (response.status) {
        searchHandler();
        setReloadFilterList(true);
      }
    } catch (error) {
      console.error(error.message);
    }

    closeFilterBlock();
  };

  //function for reset other component states
  const resetOtherComponentStates = () => {
    setColumns([]);
    setSearchReserveDate("");
    setSearchReserveIdList([]);
    setSearchReserveAmbIdList([]);
    setSearchReserveActivity([]);
    setSearchReserveLabels([]);
    setSearchReserveBenificiaries([]);
    setSearchReserveClients([]);
    setSearchReserveEducators([]);
    setSearchReserveStatus([]);
    setisConsecutiveReserveFilter(false);
    setIsTemplateReserveFilter(false);
    setUnsentMailReserveFilter(false);
  };

  //function for search
  const searchHandler = () => {
    // Extract selected column values or reset columns
    if (selectedFilterData.showColumnValue) {
      const selectedColumnValues = selectedFilterData.showColumnValue.map(
        (item) => item.value
      );
      setColumns(selectedColumnValues); // Update columns state based on selected column values
    } else {
      setColumns([]); // Reset columns state
    }

    /*===== switch statement for date input radio start ======*/
    switch (selectedFilterData.selectedRadioName) {
      case "daterange":
        if (selectedFilterData.fromDate < selectedFilterData.toDate) {
          setSearchReserveDate(
            selectedFilterData.fromDate + "|" + selectedFilterData.toDate
          ); // Set searchReserveDate for date range
        } else {
          setDateWarning(true); // Show date warning
        }
        break;

      case "todayradio":
        setSearchReserveDate(todayValue); // Set searchReserveDate for today
        break;

      case "eventdate":
        setSearchReserveDate(selectedFilterData.selectedDate); // Set searchReserveDate for event date
        break;

      default:
        setSearchReserveDate(""); // Reset searchReserveDate
        break;
    }
    /*===== switch statement for date input radio end ======*/

    // Assign data for search based on selected options

    // Update searchReserveIdList based on selected reservation IDs
    selectedFilterData.reserveSelectedIds.length > 0
      ? setSearchReserveIdList(selectedFilterData.reserveSelectedIds)
      : setSearchReserveIdList([]);

    // Update searchReserveAmbIdList based on selected reservation Amb IDs
    selectedFilterData?.reserveSelectedAmbIds?.length > 0
      ? setSearchReserveAmbIdList(selectedFilterData.reserveSelectedAmbIds)
      : setSearchReserveAmbIdList([]);

    // Update searchReserveActivity based on selected activity options
    selectedFilterData.activityOptions.length > 0
      ? setSearchReserveActivity(selectedFilterData.activityOptions)
      : setSearchReserveActivity([]);

    // Update searchReserveLabels based on selected label options
    selectedFilterData.labelOptions.length > 0
      ? setSearchReserveLabels(selectedFilterData.labelOptions)
      : setSearchReserveLabels([]);

    // Update searchReserveBenificiaries based on selected beneficiary options
    selectedFilterData.benificiaryOptions.length > 0
      ? setSearchReserveBenificiaries(selectedFilterData.benificiaryOptions)
      : setSearchReserveBenificiaries([]);

    // Update searchReserveClients based on selected client options
    selectedFilterData.clientOptions.length > 0
      ? setSearchReserveClients(selectedFilterData.clientOptions)
      : setSearchReserveClients([]);

    //update search exclude clients
    selectedFilterData.excludedClientOptions.length > 0
      ? setSearchReserveExcludeClients(selectedFilterData.excludedClientOptions)
      : setSearchReserveExcludeClients([]);

    // Update searchReserveEducators based on selected educator options
    selectedFilterData.educatorOptions.length > 0
      ? setSearchReserveEducators(selectedFilterData.educatorOptions)
      : setSearchReserveEducators([]);

    // Update searchReserveStatus based on selected reserve status options
    selectedFilterData.reserveStatusOption.length > 0
      ? setSearchReserveStatus(selectedFilterData.reserveStatusOption)
      : setSearchReserveStatus([]);

    // Set filters for consecutive and template reserves
    setisConsecutiveReserveFilter(selectedFilterData.isConsecutive); // Update isConsecutiveReserveFilter state
    setIsTemplateReserveFilter(selectedFilterData.isTemplate); // Update isTemplateReserveFilter state
    setUnsentMailReserveFilter(selectedFilterData.unsentMail);
    setIsDefaultReserveFilter(selectedFilterData.isDefault);

    closeFilterBlock();
  };

  //function for reset filter
  const resetFilterHandler = () => {
    setFilterName("");
    setIsConseCutive(false);
    setIsTemplate(false);
    setSelectedDatesPick([]);
    setSelectedFilterData({
      ...selectedFilterData,
      showColumnValue: null,
      showSelectedColumns: [],
      selectedRadioName: "",
      fromDate: "",
      toDate: "",
      selectedDate: "",
      reserveIdValue: null,
      reserveSelectedIds: [],
      reserveAmbIdValue: null,
      reserveSelectedAmbIds: [],
      reserveStatusValue: null,
      reserveStatusOption: [],
      mailValue: null,
      mailOptions: null,
      benificiaryValue: null,
      benificiaryOptions: [],
      activityValue: null,
      activityOptions: [],
      labelValue: null,
      labelOptions: [],
      clientValue: null,
      clientOptions: [],
      excludedClientOptions: [],
      excludedClientValue: null,
      educatorValue: null,
      educatorOptions: [],
    });
    setIsDefault(false);
    resetOtherComponentStates();
    //closeFilterBlock();
    setReloadReservationList(true);
  };

  //function for close filter collapse
  const closeFilterBlock = () => {
    // toggle the filter block
    var filterCollapseDiv = document.getElementById("filterCollapse");
    // Remove the class from the div element
    filterCollapseDiv.classList.remove("show");
  };

  // useEffect(() => {
  //   if (reloadRefresh) {
  //     resetHandler();
  //     setReloadRefresh(false);
  //   }
  // }, [reloadRefresh]);

  //function for default filter
  const defaultFilterHandler = async () => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_DEFAULT_FILTER + `?token=${token}`;

      // console.log("filter request url >>", requestUrl);

      const response = await getData(requestUrl);

      // console.log("default filter response >>>", response);

      if (response.status) {
        if (response.data) {
          let filterData = response.data;

          if (filterData.isdefault) {
            const jsonFilterData = JSON.parse(filterData.parameters);

            // Extract selected column values or reset columns
            if (jsonFilterData.showColumnValue) {
              const selectedColumnValues = jsonFilterData.showColumnValue.map(
                (item) => item.value
              );
              setColumns(selectedColumnValues); // Update columns state based on selected column values
            } else {
              setColumns([]); // Reset columns state
            }

            // Date is intentionally not auto-applied from the saved default filter.
            // The date defaults to "today" via the quick filter in ReservationList,
            // and is only overridden when the user explicitly submits the filter panel.

            // Assign data for search based on selected options

            // Update searchReserveIdList based on selected reservation IDs
            jsonFilterData.reserveSelectedIds.length > 0 &&
              setSearchReserveIdList(jsonFilterData.reserveSelectedIds);

            // Reset searchReserveIdList if no reservation IDs are selected
            jsonFilterData.reserveSelectedIds.length == 0 &&
              setSearchReserveIdList([]);

            // Update searchReserveActivity based on selected activity options
            jsonFilterData.activityOptions.length > 0 &&
              setSearchReserveActivity(jsonFilterData.activityOptions);

            // Update searchReserveLabels based on selected label options
            selectedFilterData.labelOptions.length > 0 &&
              setSearchReserveLabels(jsonFilterData.labelOptions);

            // Update searchReserveBenificiaries based on selected beneficiary options
            jsonFilterData.benificiaryOptions.length > 0 &&
              setSearchReserveBenificiaries(jsonFilterData.benificiaryOptions);

            // Update searchReserveClients based on selected client options
            jsonFilterData.clientOptions.length > 0 &&
              setSearchReserveClients(jsonFilterData.clientOptions);

            //update exclude client
            jsonFilterData.excludedClientOptions.length > 0 &&
              setSearchReserveClients(jsonFilterData.excludedClientOptions);

            // Update searchReserveEducators based on selected educator options
            jsonFilterData.educatorOptions.length > 0 &&
              setSearchReserveEducators(jsonFilterData.educatorOptions);

            // Update searchReserveStatus based on selected reserve status options
            jsonFilterData.reserveStatusOption.length > 0 &&
              setSearchReserveStatus(jsonFilterData.reserveStatusOption);

            // Set filters for consecutive and template reserves
            setisConsecutiveReserveFilter(jsonFilterData.isConsecutive); // Update isConsecutiveReserveFilter state
            setUnsentMailReserveFilter(jsonFilterData.unsentMail);
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (isSearchExecute) {
      searchHandler();
      setIsSearchExecute(false);
    }
  }, [isSearchExecute]);

  useEffect(() => {
    if (resetFilterData) {
      resetFilterHandler();
      setResetFilterData(false);
    }
  }, [resetFilterData]);

  useEffect(() => {
    if (filterTitle !== "" && filterJsonData && filterId) {
      setFilterName(filterTitle);
      setIsDefault(filterDefault);
      setSelectedFilterData(filterJsonData);

      //assign dates in Date picker
      if (filterJsonData.selectedDate != "") {
        // Simulated API response string
        const apiDateString = filterJsonData.selectedDate;

        // Split the API response string into individual date strings
        const dateStrings = apiDateString.split(",");

        // Convert date strings to JavaScript Date objects
        const parsedDates = dateStrings.map((dateString) => {
          const [day, month, year] = dateString.split("-");
          return new Date(year, month - 1, day); // Month is 0-based in Date object
        });

        // Set the parsed dates as the initial selected dates
        setSelectedDatesPick(parsedDates);
      } else {
        setSelectedDatesPick([]);
      }
    }
  }, [filterTitle, filterJsonData, filterId, filterDefault]);

  useEffect(() => {
    getAllLabels();
    getAllActivity();
    getALlClientList();
    getALlEducatorList();
    defaultFilterHandler();
  }, []);

  // Returns true when a react-select value has at least one entry selected
  const isSelected = (val) => Array.isArray(val) ? val.length > 0 : !!val;

  // Shared styles for react-select inside a highlighted tile
  const selectedTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({ ...base, backgroundColor: "transparent", borderColor: "transparent", boxShadow: "none" }),
  };

  const defaultTileStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className="collapse mt-3" id="filterCollapse">
      <div className="p-3 bg-gray-200">
        <form onSubmit={(e) => e.preventDefault()}>

          {/* ===== BLOCK 1 : Filter by Date ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>calendar_month</span>
              {t("Filter by Date")}
            </p>
            <div className="row g-3 align-items-start">

              {/* a) Range */}
              <div className="col-lg-4">
                <div
                  className={`border rounded p-2 h-100 ${selectedFilterData.selectedRadioName === "daterange" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedFilterData((prev) => ({ ...prev, selectedRadioName: "daterange" })); setDateWarning(false); }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="dateGroup"
                      id="rv_dateRange"
                      value="daterange"
                      checked={selectedFilterData.selectedRadioName === "daterange"}
                      onChange={radioCheckHandler}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="rv_dateRange" style={{ cursor: "pointer" }}>
                      {t("Range")}
                    </label>
                  </div>
                  <div className="d-sm-flex gap-2">
                    <div className="flex-fill" onClick={(e) => e.stopPropagation()}>
                      <DatePicker
                        format="DD-MM-YYYY"
                        calendarPosition="bottom-center"
                        locale={i18n.language == "en" ? "en" : spanishLocale}
                        weekStartDayIndex={1}
                        inputClass="form-control form-control-sm bg-white"
                        placeholder={t("From date")}
                        value={selectedFilterData?.fromDate ? formatStringDate(selectedFilterData.fromDate) : ""}
                        onChange={(e) => {
                          const formattedDate = e.format("YYYY-MM-DD");
                          setSelectedDatesPick([]);
                          setSelectedFilterData((prevData) => ({
                            ...prevData,
                            selectedRadioName: "daterange",
                            fromDate: formattedDate,
                            selectedDate: "",
                          }));
                          setDateWarning(false);
                        }}
                      />
                    </div>
                    <div className="flex-fill mt-2 mt-sm-0" onClick={(e) => e.stopPropagation()}>
                      <DatePicker
                        format="DD-MM-YYYY"
                        calendarPosition="bottom-center"
                        locale={i18n.language == "en" ? "en" : spanishLocale}
                        weekStartDayIndex={1}
                        inputClass="form-control form-control-sm bg-white"
                        placeholder={t("To date")}
                        value={selectedFilterData?.toDate ? formatStringDate(selectedFilterData.toDate) : ""}
                        onChange={(e) => {
                          const formattedDate = e.format("YYYY-MM-DD");
                          setSelectedDatesPick([]);
                          setSelectedFilterData((prevData) => ({
                            ...prevData,
                            selectedRadioName: "daterange",
                            toDate: formattedDate,
                            selectedDate: "",
                          }));
                          setDateWarning(false);
                        }}
                      />
                    </div>
                  </div>
                  {dateWarning && (
                    <p className="d-flex align-items-center gap-1 text-danger small mb-0 mt-1">
                      <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>warning</span>
                      {t("End date should be greater than start date")}!
                    </p>
                  )}
                </div>
              </div>

              {/* b) Today */}
              <div className="col-lg-2">
                <div
                  className={`border rounded p-2 h-100 d-flex align-items-center gap-2 ${selectedFilterData.selectedRadioName === "todayradio" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedFilterData((prev) => ({ ...prev, selectedRadioName: "todayradio" })); setDateWarning(false); }}
                >
                  <input
                    className="form-check-input mt-0"
                    type="radio"
                    name="dateGroup"
                    id="rv_today"
                    value="todayradio"
                    checked={selectedFilterData.selectedRadioName === "todayradio"}
                    onChange={radioCheckHandler}
                  />
                  <label className="form-check-label fw-medium mb-0" htmlFor="rv_today" style={{ cursor: "pointer" }}>
                    <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "16px" }}>today</span>
                    {t("Today")}
                  </label>
                </div>
              </div>

              {/* c) Multiple Dates */}
              <div className="col-lg-6">
                <div
                  className={`border rounded p-2 h-100 ${selectedFilterData.selectedRadioName === "eventdate" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedFilterData((prev) => ({ ...prev, selectedRadioName: "eventdate" })); setDateWarning(false); }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="dateGroup"
                      id="rv_multipleDates"
                      value="eventdate"
                      checked={selectedFilterData.selectedRadioName === "eventdate"}
                      onChange={radioCheckHandler}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="rv_multipleDates" style={{ cursor: "pointer" }}>
                      {t("Selected Dates")}
                    </label>
                  </div>
                  <div className="w-100" onClick={(e) => e.stopPropagation()}>
                    <DatePicker
                      multiple
                      format="DD-MM-YYYY"
                      locale={i18n.language == "en" ? "en" : spanishLocale}
                      weekStartDayIndex={1}
                      inputClass="form-control form-control-sm bg-white"
                      containerStyle={{ width: "100%" }}
                      value={selectedDatesPick}
                      onChange={datePickerChangeHandler}
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 1 ===== */}

          {/* ===== BLOCK 2 : Reserve Filters ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>filter_list</span>
              {t("Filter by Reserve Details")}
            </p>

            {/* Row 1: IDs + Activity + Label */}
            <div className="row g-3 mb-3">
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.reserveIdValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Customer ID")}</label>
                  <CreatableSelect
                    isMulti
                    placeholder={t("e.g. 10045")}
                    value={selectedFilterData.reserveIdValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        reserveIdValue: val,
                        reserveSelectedIds: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.reserveIdValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.reserveAmbIdValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("AMB ID")}</label>
                  <CreatableSelect
                    isMulti
                    placeholder={t("e.g. AMB-001")}
                    value={selectedFilterData.reserveAmbIdValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        reserveAmbIdValue: val,
                        reserveSelectedAmbIds: val.map((label) => label.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.reserveAmbIdValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.activityValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Activity")}</label>
                  <Select
                    ref={activitySelectRef}
                    placeholder={t("Select activity")}
                    options={getSortedOptions(activityList, activitySearchInput)}
                    isMulti
                    value={selectedFilterData.activityValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        activityValue: val,
                        activityOptions: val.map((label) => label.value),
                      }))
                    }
                    onInputChange={handleInputChange(setActivitySearchInput, activitySelectRef)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.activityValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.labelValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Label")}</label>
                  <Select
                    ref={labelSelectRef}
                    placeholder={t("Select label")}
                    options={getSortedOptions(labelList, labelSearchInput)}
                    isMulti
                    value={selectedFilterData.labelValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        labelValue: val,
                        labelOptions: val.map((label) => label.value),
                      }))
                    }
                    onInputChange={handleInputChange(setLabelSearchInput, labelSelectRef)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.labelValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
            </div>

            {/* Row 2: Beneficiary + Clients + Educators */}
            <div className="row g-3 mb-3">
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.benificiaryValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Beneficiary")}</label>
                  <Select
                    ref={beneficiarySelectRef}
                    placeholder={t("Select beneficiary")}
                    options={getSortedOptions(benificiaryList, beneficiarySearchInput)}
                    isMulti
                    value={selectedFilterData.benificiaryValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        benificiaryValue: val,
                        benificiaryOptions: val.map((benificiary) => benificiary.value),
                      }))
                    }
                    onInputChange={handleInputChange(setBeneficiarySearchInput, beneficiarySelectRef)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.benificiaryValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.clientValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Include Clients")}</label>
                  <Select
                    ref={clientSelectRef}
                    placeholder={t("Select clients")}
                    isMulti
                    options={getSortedOptions(clientList, clientSearchInput)}
                    value={selectedFilterData.clientValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        clientValue: val,
                        clientOptions: val.map((client) => client.value),
                      }))
                    }
                    onInputChange={handleInputChange(setClientSearchInput, clientSelectRef)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.clientValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.excludedClientValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Exclude Clients")}</label>
                  <Select
                    ref={excludeClientSelectRef}
                    placeholder={t("Select clients")}
                    isMulti
                    options={getSortedOptions(clientList, excludeClientSearchInput)}
                    value={selectedFilterData.excludedClientValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        excludedClientValue: val,
                        excludedClientOptions: val.map((client) => client.value),
                      }))
                    }
                    onInputChange={handleInputChange(setExcludeClientSearchInput, excludeClientSelectRef)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.excludedClientValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.educatorValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Educators")}</label>
                  <Select
                    ref={educatorSelectRef}
                    placeholder={t("Select educators")}
                    isMulti
                    options={getSortedOptions(educatorList, educatorSearchInput)}
                    value={selectedFilterData.educatorValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        educatorValue: val,
                        educatorOptions: val.map((educator) => educator.value),
                      }))
                    }
                    onInputChange={handleInputChange(setEducatorSearchInput, educatorSelectRef)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.educatorValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
            </div>

            {/* Row 3: Status + Checkboxes */}
            <div className="row g-3 align-items-center">
              <div className="col-lg-3">
                <div className={`border rounded p-2 h-100 ${isSelected(selectedFilterData.reserveStatusValue) ? "border-primary bg-primary bg-opacity-10" : ""}`}>
                  <label className="form-label small text-muted mb-1">{t("Status")}</label>
                  <Select
                    placeholder={t("Select status")}
                    options={ReserveStatus}
                    isMulti
                    value={selectedFilterData.reserveStatusValue}
                    onChange={(val) =>
                      setSelectedFilterData((prevData) => ({
                        ...prevData,
                        reserveStatusValue: val,
                        reserveStatusOption: val.map((status) => status.value),
                      }))
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={isSelected(selectedFilterData.reserveStatusValue) ? selectedTileStyles : defaultTileStyles}
                  />
                </div>
              </div>
              <div className="col-lg-9">
                <div className="d-flex flex-wrap gap-3 align-items-center pt-lg-3">
                  {/* Consecutive Events */}
                  <div
                    className={`border rounded px-3 py-2 form-check mb-0 ${selectedFilterData.isConsecutive ? "border-primary bg-primary bg-opacity-10" : ""}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedFilterData((prev) => ({ ...prev, isConsecutive: !prev.isConsecutive }))}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="rv_consecutive"
                      checked={selectedFilterData.isConsecutive}
                      onChange={(e) =>
                        setSelectedFilterData((prevData) => ({
                          ...prevData,
                          isConsecutive: e.target.checked,
                        }))
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label className="form-check-label small" htmlFor="rv_consecutive" style={{ cursor: "pointer" }}>
                      {t("Filter only Consecutive Events")}
                    </label>
                  </div>
                  {/* Unsent Mail */}
                  <div
                    className={`border rounded px-3 py-2 form-check mb-0 ${selectedFilterData.unsentMail ? "border-primary bg-primary bg-opacity-10" : ""}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setSelectedFilterData((prev) => ({ ...prev, unsentMail: !prev.unsentMail }))}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="rv_unsentMail"
                      checked={selectedFilterData.unsentMail}
                      onChange={(e) =>
                        setSelectedFilterData((prevData) => ({
                          ...prevData,
                          unsentMail: e.target.checked,
                        }))
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label className="form-check-label small" htmlFor="rv_unsentMail" style={{ cursor: "pointer" }}>
                      {t("Unsent mail")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ===== END BLOCK 2 ===== */}

          {/* ===== BLOCK 3 : Save Filter ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>bookmark</span>
              {t("Save as a new filter")}
            </p>
            <div className="d-flex align-items-center gap-3">
              <div className="position-relative" style={{ width: "50%" }}>
                <input
                  type="text"
                  id="filtername"
                  className="form-control"
                  placeholder={t("Add filter name")}
                  value={filterName}
                  onChange={(e) => setFilterName(e.target.value)}
                />
                {filterName && (
                  <span
                    className="material-symbols-outlined position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                    style={{ fontSize: "18px", cursor: "pointer" }}
                    onClick={deleteSelectedFilter}
                    title={t("Clear filter name")}
                  >
                    close
                  </span>
                )}
              </div>
              <div className="form-check mb-0 text-nowrap">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="rv_isDefault"
                  checked={isDefault}
                  onChange={(e) => setIsDefault(e.target.checked)}
                />
                <label className="form-check-label small" htmlFor="rv_isDefault">
                  {t("Set as default filter")}
                </label>
              </div>
            </div>
          </div>
          {/* ===== END BLOCK 3 ===== */}

          {/* ===== Actions ===== */}
          <div className="d-flex gap-3 align-items-center justify-content-end">
            <Link
              to="#"
              className="d-flex gap-1 align-items-center text-secondary"
              onClick={resetFilterHandler}
            >
              <span className="material-symbols-outlined icon-md">sync</span>
              <span className="fw-medium">{t("Reset")}</span>
            </Link>
            <button
              type="submit"
              className="btn btn-primary px-4 d-flex align-items-center gap-2"
              onClick={searchHandler}
            >
              <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>search</span>
              {t("Filter")}
            </button>
            <button
              type="button"
              className="btn btn-outline-primary px-4 d-flex align-items-center gap-2"
              onClick={saveWithFilterSearchHandler}
            >
              <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>save</span>
              {t("Save & Filter")}
            </button>
          </div>
          {/* ===== End Actions ===== */}

        </form>
      </div>
    </div>
  );
};

export default ReserveFilter;
